import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useButtonStyles = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.BUTTON_STYLES(),
    queryFn: () => shopApi.fetchButtonStyles(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.BUTTON_STYLES(),
    });
  };

  return {
    isLoading,
    isFetching,
    buttonStyles: data?.data ?? [],
    invalidate,
  };
};
